import styled from "@emotion/styled/macro";
import { colors } from "../../../../../common/styles/theme.styles";

export const DropdownSearchContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 0px 16px 16px;
    ${({ showBorder }) => showBorder && 'border-bottom: 1px solid #DDE3EB;'}
    margin-bottom: 8px;
`;

export const DropdownSearchInput = styled.input`
    border: none;
    outline: none;
    background: transparent;
    font-size: 12px;
    font-family: Circular;
    font-weight: 450;
    line-height: 1.265;
    color: ${colors.darkGray1};
    flex: 1;

    &::placeholder {
        color: ${colors.darkGray3};
    }
`; 